import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import HeroScorecardSection from "../../../components/hero/heroScorecardSection";
import "./scorecardHome.css";
import "../../../popUpForms/formModals/formModal.css";
import "../../../index.css";
import Header from "../../Navigation/header";
import ScorecardHomeSubHeader from "./scorecardHomeSubHeader";
import Footer from "../../Navigation/footer";
import SecondaryScorecardMenu from "../../Navigation/secondaryScorecardMenu";
import CardScorecardPreparationMatters from "./scorecardHomeCards/cardScorecardPreparationMatters";
import CardScorecardOverviewScorecard from "./scorecardHomeCards/cardScorecardOverviewScorecard";
import CardScorecardAssessWildfireRisk from "./scorecardHomeCards/cardScorecardAssessWildfireRisk";
import CardScorecardCollaborateWithUs from "./scorecardHomeCards/cardScorecardCollaborateWithUs";
import CardScorecardSubscribeForUpdates from "./scorecardHomeCards/cardScorecardSubscribeForUpdates";
import CardScorecardShareFeedback from "./scorecardHomeCards/cardScorecardShareFeedback";
import CardScorecardNeedSupport from "./scorecardHomeCards/cardScorecardNeedSupport";
import CardScorecardContributeToTheCause from "./scorecardHomeCards/cardScorecardContributeToTheCause";

const ScorecardHome = () => {
  const [isVisible, setIsVisible] = useState();
  const [hoveredTab, setHoveredTab] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Helmet>
        <title>Community Wildfire Resilience Scorecard | CWPC</title>

        <meta
          name="description"
          content="Assess wildfire preparedness and strengthen community resilience with the Community Wildfire Resilience Scorecard developed by CWPC and ARISE-US."
        />

        <link
          rel="canonical"
          href="https://preventwildfire.world/scorecard"
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:site_name"
          content="Catastrophic Wildfire Prevention Consortium"
        />

        <meta
          property="og:title"
          content="Community Wildfire Resilience Scorecard | CWPC"
        />

        <meta
          property="og:description"
          content="Evaluate wildfire risk, identify vulnerabilities, and strengthen community preparedness using the CWPC Community Wildfire Resilience Scorecard."
        />

        <meta
          property="og:url"
          content="https://preventwildfire.world/scorecard"
        />

        <meta
          property="og:image"
          content="https://preventwildfire.world/assets/og-default.jpg"
        />
      </Helmet>
      <ScorecardHomeSubHeader />
      <HeroScorecardSection />
      <SecondaryScorecardMenu
        hoveredTab={hoveredTab}
        onTabHover={(tabName) => setHoveredTab(tabName)}
        onTabLeave={() => setHoveredTab(null)}
      />
      <div className="card-container">
        <div className="card-sub-container large-screen-limit">
          <CardScorecardPreparationMatters
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardScorecardOverviewScorecard
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardScorecardAssessWildfireRisk
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardScorecardCollaborateWithUs
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardScorecardSubscribeForUpdates
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardScorecardShareFeedback
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardScorecardNeedSupport
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardScorecardContributeToTheCause
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />

          <div
            onClick={handleBackToTop}
            className={isVisible ? "back-to-top visible" : "back-to-top"}
            aria-label="Link to go back to the top"
            title="back-to-top"
          >
            <i className="fa-solid fa-circle-arrow-up fa-2xl"></i>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScorecardHome;
